import React, { Component } from 'react';
import { Redirect, Route, Switch } from "react-router";
import LoadingIndicator from '../common/LoadingIndicator';
import NotFound from '../common/NotFound';
import Layout from "../common/layout";
import { allow2Oauth, allowRegister } from "../constants/config";
import ActiveAccount from "../user/active/Active";
import ChangePassword from "../user/change-password/ChangePassword";
import ForgotPassWord from "../user/forgotPassword/ForgotPassword";
import AcceptInvite from "../user/invite/AcceptInvite";
import Login from '../user/login/Login';
import OAuth2RedirectHandler from '../user/oauth2/OAuth2RedirectHandler';
import CreateOrg from "../user/signup/CreateOrg";
import Signup from '../user/signup/Signup';
import SignupSuccess from "../user/signup/signupSuccess";
import { getCurrentUser } from '../util/APIUtils';
import ChangeEmail from '../user/change-email/ChangeEmail';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      currentUser: null,
      loading: true
    }

    this.loadCurrentlyLoggedInUser = this.loadCurrentlyLoggedInUser.bind(this);
  }

  loadCurrentlyLoggedInUser() {
    getCurrentUser()
      .then(response => {
        this.setState({
          currentUser: response,
          authenticated: true,
          loading: false
        });
      }).catch(() => {
      this.setState({
        loading: false
      });
    });
  }

  componentDidMount() {
    this.loadCurrentlyLoggedInUser();
  }

  render() {
    if (this.state.loading) {
      return <LoadingIndicator/>
    }

    return (
      <Layout>
        <Switch>
          <Route exact path="/">
            <Redirect to="/login"/>
          </Route>
          <Route path="/login" component={Login} />
          <Route path="/sign-up-success" component={SignupSuccess} />
          <Route path="/activate" component={ActiveAccount} />
          <Route path="/create-org" component={CreateOrg} />
          <Route path="/invite/accept/:id" component={AcceptInvite} />
          <Route path="/change-email" component={ChangeEmail} />
          <Route path="/change-password" component={ChangePassword} />
          <Route path="/forgot-password" component={ForgotPassWord} />
          {/*{allowRegister && <Route path="/signup" component={Signup}/>}*/}
          {allow2Oauth && <Route path="/oauth2/redirect" component={OAuth2RedirectHandler}/>}
          {/*{allowActive && <Route path="/activate" component={Active}/>}*/}
          <Route component={NotFound}/>
        </Switch>
      </Layout>
    );
  }
}

export default App;
